exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-home-layout{opacity:1;transition:opacity .1s ease-in-out}.page-home-layout_hidden{opacity:0}.page-home-layout .content .text h1{width:100%;margin-top:0;margin-bottom:29px;padding-bottom:13px;font-weight:300;color:rgba(0,0,0,.85);border-bottom:1px solid #d3d4d9;font-size:40px;line-height:100%}.page-home-layout .content .text h1,.page-home-layout .content .text h2{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:text;font-family:Open Sans,sans-serif}.page-home-layout .content .text h2{font-weight:700;font-size:16px;text-transform:uppercase}.page-home-layout .content .text p{margin-bottom:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28c099d1","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/home/Home.vue
// module id = f2bb4c4dda88828a0637
// module chunks = 16